module.exports = __webpack_public_path__ + "img/avatar4.6a19af76.png";